import { SVGProps } from 'react';

export enum IconSize {
  SIZE16 = '16',
  SIZE20 = '20',
  SIZE24 = '24',
  SIZE30 = '30',
  SIZE32 = '32',
}
export interface IconProps extends Omit<SVGProps<SVGElement>, 'ref'> {
  size?: IconSize;
  className?: string;
  color?: string;
}
